<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     接入点详情
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="mb-md">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>
    <el-alert v-if="ap.ap_expired" type="error" class="mb">
      <div slot="title">
        <span>该接入点已欠费，请尽快充值，以免影响正常使用。</span>
        <span class="ml"><el-button size="mini" type="danger" @click="handleRecharge">立即充值</el-button></span>
      </div>
    </el-alert>

    <el-card v-loading="loading" shadow="never">
      <div slot="header">
        <span class="font-2x">{{ ap.simid }}</span>
        <span v-if="ap.expire_day" class="ml text-muted" :class="{ 'text-danger': ap.ap_expired }">（有效期至 {{ ap.expire_day | parseTime('{y}/{m}/{d}') }}）</span>
        <span v-if="ap.ap_expired" class="pull-right mr-lg">
          <el-popover
            placement="right"
            trigger="hover">
            <div class="text-center">移至回收站</div>
            <i slot="reference" role="button" class="el-icon-delete font-2x text-danger" @click="deleteAp"></i>
          </el-popover>
        </span>
      </div>
      <div class="flex">
        <div style="flex: auto">
          <el-form ref="apForm" class="display-form" label-position="left" :model="ap" label-width="120px">
            <el-form-item label="接入点状态">
              <div class="flex align-items-center">
                <span v-if="ap.is_online" class="text-success font-lg">
                  <i class="iconfont icon-circle-outline"></i>
                </span>
                <span v-else class="text-muted font-lg">
                  <i class="iconfont icon-circle-fill"></i>
                </span>
                <span class="ml-xs">{{ ap.is_online ? '在线' : '离线' }}</span>
              </div>
            </el-form-item>
            <el-form-item label="创建时间">
              <span>{{ ap.createtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
            </el-form-item>

            <template v-if="ap.first_activation">
              <el-form-item label="激活时间">
                <span>{{ ap.first_activation | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
              </el-form-item>
              <el-form-item label="最近通讯时间">
                <span>{{ ap.last_upload_time | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
              </el-form-item>
            </template>

            <template v-else>
              <el-form-item label="激活时间">
                <span>未激活</span>
              </el-form-item>
              <el-form-item label="沉默日期">
                <div class="flex align-items-center">
                  <span>{{ ap.silent_deadline | parseTime('{y}/{m}/{d}') }}</span>
                  <el-popover
                    placement="top"
                    trigger="hover">
                    超出沉默日期，接入点将被强制激活
                    <span slot="reference" class="ml-sm text-muted font-2x">
                      <i class="iconfont icon-circle-question"></i>
                    </span>
                  </el-popover>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <div class="ml bg-light radius5 flex column" style="flex: none; width: 30%">
          <div class="hd front-line mt ml">通讯终端</div>
          <div class="bd flex-center column">
            <div class="text-light">
              <i class="iconfont icon-Ap" style="font-size: 100px;"></i>
            </div>
            <div>
              <div class="mt">
                <span>终端型号：</span>
                <span class="ml-xs">{{ ap.dtu_model || '其他' }}</span>
              </div>
              <div v-if="ap.msisdn" class="flex align-items-center mt-xs">
                <span>物联卡号：</span>
                <span class="ml-xs">{{ ap.msisdn }}</span>
                <span class="ml-xs text-blue font-lg">
                  <i class="iconfont icon-cmcc"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="ml bg-light radius5 flex column" style="flex: none; width: 30%">
          <div class="hd front-line mt ml">绑定设备</div>
          <div class="bd flex-center column">
            <div>
              <f-equip-avatar
                size="huge"
                :equip="{ equipid: ap.sim_equipid, name: ap.equip_name }"
                :default-show-go="false"
              />
            </div>
            <div class="mt">
              <f-equip-name :equip="{ equipid: ap.sim_equipid, name: ap.equip_name }" />
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="mt" shadow="never">
      <ap-flow-pie />
    </el-card>
  </div>
</template>

<script>
import ApFlowPie from './components/ApFlowPie'
import { apApGetApi, apDeleteApi } from '@/api/ap/apApi'
import { apCartPostApi } from '@/api/ap/apRechargeApi'
export default {
  components: {
    ApFlowPie
  },
  data() {
    return {
      simid: this.$route.query.simid,
      loading: false,
      ap: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      apApGetApi({ simid: this.simid }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.ap = Object.assign({}, res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleRecharge() {
      const tempData = {
        simid: this.simid,
        num: 1,
        productid: this.ap.productid
      }
      apCartPostApi({ data: [tempData] }).then(res => {
        if (res.errno === 0) {
          this.$router.push('/ap/recharge/cart')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    deleteAp() {
      this.$confirm(`将接入点 <span class="font-md text-success">${this.ap.simid}</span> 移至回收站，同时将设备 <span class="font-md text-success">${this.ap.equip_name}</span>  一并从设备监控列表删除，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        apDeleteApi({ simid: this.ap.simid }).then(res => {
          if (res.errno === 0) {
            this.$message.success('接入点 ' + this.ap.simid + ' 删除成功，可去接入点回收站赎回！')
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
